module.exports = __webpack_public_path__ + "img/Icon-Navigation-expand-1.665bbf5f.svg";